import { render, staticRenderFns } from "./MultilistPageLists.vue?vue&type=template&id=05857f6f&scoped=true"
import script from "./MultilistPageLists.vue?vue&type=script&lang=js"
export * from "./MultilistPageLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05857f6f",
  null
  
)

export default component.exports